import { motion } from "framer-motion";
import { Truck, ShieldCheck, PhoneCall, BadgeCheck, Quote } from "lucide-react";

const POINTS = [
  { icon: Truck, title: "Her An Hazır", text: "Bakımlı çekicimiz her an yola hazır; aradığınızda dakikalar içinde çıkıyoruz." },
  { icon: ShieldCheck, title: "Hasarsız Taşıma", text: "Aracınız yere değmeden, kilitlenerek yüklenir; teslimde hiçbir sorun çıkmaz." },
  { icon: PhoneCall, title: "Telefonda Çözüm", text: "İlk aramada konumunuzu alır, net fiyatı ve varış süresini söyleriz." },
  { icon: BadgeCheck, title: "Tek Kişiye Net", text: "İşin başından sonuna kadar kendimiz yönetiriz; aracınız el değiştirmez." },
];

export default function WhyUs() {
  return (
    <section id="neden-biz" data-testid="why-us-section" className="py-16 lg:py-24 scroll-mt-20 bg-night-800/40 border-y border-white/5 relative overflow-hidden">
      <div className="hazard-stripes-soft absolute inset-0 pointer-events-none" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <div className="lg:col-span-7">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-brand">Neden Konya Çekicim?</p>
            <h2 className="font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-6xl text-white mt-3 leading-[0.95]">
              Çünkü yolda kalan
              <br />
              <span className="text-outline">bekleyemez</span>
            </h2>
          </motion.div>
          <div className="mt-9 grid sm:grid-cols-2 gap-4">
            {POINTS.map(({ icon: Icon, title, text }, i) => (
              <motion.div
                key={title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                data-testid={`why-us-point-${i}`}
                className="rounded-2xl border border-white/10 bg-night-900/70 p-6 hover:border-brand/50 transition-colors duration-300"
              >
                <Icon className="w-7 h-7 text-brand" strokeWidth={2.2} />
                <h3 className="font-display font-bold uppercase text-xl mt-3 text-white">{title}</h3>
                <p className="text-sm text-slate-400 mt-2 leading-relaxed">{text}</p>
              </motion.div>
            ))}
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="lg:col-span-5"
        >
          <div className="glass-card rounded-2xl p-8 relative" data-testid="owner-card">
            <img
              src="/adem-oto-plaque.webp"
              alt="Adem Oto Kurtarma tabela logosu – Adem ILDIRAR, 0539 219 60 17"
              className="w-full h-44 object-cover rounded-xl border border-brand/30 mb-5"
              loading="lazy"
              data-testid="owner-plaque-image"
            />
            <Quote className="w-10 h-10 text-brand/40" aria-hidden="true" />
            <p className="font-display text-2xl sm:text-3xl text-white leading-snug mt-4">
              "Yolda kalan kimseyi bekletmem. Telefonunuz ister gece üçte açılsın ister bayram
              sabahı — biz nöbetiz."
            </p>
            <div className="mt-7 flex items-center gap-4">
              <img src="/logo-badge-dark.png" alt="" width="56" height="56" className="w-14 h-14 rounded-xl shrink-0" />
              <div>
                <p className="font-bold text-white text-lg" data-testid="owner-name">Adem ILDIRAR</p>
                <p className="text-sm text-slate-400">Kurucu · Konya Çekicim</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
